import React from 'react';
import { Modal, Steps, Button, Row, Col, Select, Icon, Descriptions, Tag, Alert, Input, Radio, Switch } from 'antd';
import InputMask from '~/components/UI/InputMask';
import Tip from '~/components/Tip';
import moment from 'moment';

import { DatePicker } from '~/components/UI/DatePicker/Locale';
import InputCurrency, { currency2Float, toBRL } from '~/components/UI/InputCurrency';

var Step = Steps.Step;
var Option = Select.Option;

var METHODS = [
    { value: 1, label: 'Dinheiro' },
    { value: 2, label: 'Boleto' },
    { value: 3, label: 'Cartão' },
    { value: 4, label: 'Transferência' },
    { value: 5, label: 'Pix' },
];

var SPLIT_OPTIONS = [];
for (var i = 1; i <= 12; i++) {
    SPLIT_OPTIONS.push(i);
}

function isA3Type(type) {
    return type && type.toUpperCase().indexOf('A3') >= 0;
}

class RenewalWizard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentStep: 0, // 0=Dados, 1=Datas, 2=Valor, 3=Resumo
            // Certificate fields
            nature: '',
            type: '',
            owner_name: '',
            document: '',
            fenacon: '',
            password: '',
            bird: false,
            notes: '',
            scheduled_at: null,
            showPassword: false,
            // Dates & billing
            emission_date: null,
            due_date: null,
            amount: null,
            generateBilling: false,
            payment_split: 1,
            method: 2,
            billing_due_date: null,
        };
        this.onEmissionChange = this.onEmissionChange.bind(this);
        this.onDueDateChange = this.onDueDateChange.bind(this);
        this.onAmountChange = this.onAmountChange.bind(this);
        this.onSplitChange = this.onSplitChange.bind(this);
        this.onMethodChange = this.onMethodChange.bind(this);
        this.onBillingDueDateChange = this.onBillingDueDateChange.bind(this);
        this.onGenerateBillingChange = this.onGenerateBillingChange.bind(this);
        this.goNext = this.goNext.bind(this);
        this.goPrev = this.goPrev.bind(this);
        this.handleConfirm = this.handleConfirm.bind(this);
        this.handleClose = this.handleClose.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (this.props.visible && !prevProps.visible) {
            var cert = this.props.certificate || {};
            this.setState({
                currentStep: 0, // 0=Dados, 1=Datas, 2=Valor, 3=Resumo
                nature: cert.nature || 'PJ',
                type: cert.type || '',
                owner_name: cert.owner_name || '',
                document: cert.document || '',
                fenacon: cert.fenacon || '',
                password: cert.password || '',
                bird: !!cert.bird,
                notes: cert.notes || '',
                scheduled_at: cert.scheduled_at ? moment(cert.scheduled_at) : null,
                showPassword: false,
                emission_date: null,
                due_date: null,
                amount: cert.amount ? toBRL(parseFloat(cert.amount)) : null,
                generateBilling: false,
                payment_split: 1,
                method: 2,
                billing_due_date: null,
            });
        }
    }

    onEmissionChange(date) {
        var cert = this.props.certificate || {};
        var newState = { emission_date: date };
        if (date) {
            var years = isA3Type(cert.type) ? 3 : 1;
            newState.due_date = moment(date).add(years, 'years');
            if (!this.state.billing_due_date) {
                newState.billing_due_date = moment(date);
            }
        }
        this.setState(newState);
    }

    onDueDateChange(date) {
        this.setState({ due_date: date });
    }

    onAmountChange(value) {
        this.setState({ amount: currency2Float(value) });
    }

    onSplitChange(value) {
        this.setState({ payment_split: value });
    }

    onMethodChange(value) {
        this.setState({ method: value });
    }

    onBillingDueDateChange(date) {
        this.setState({ billing_due_date: date });
    }

    onGenerateBillingChange(checked) {
        this.setState({ generateBilling: checked });
    }

    goNext() {
        this.setState({ currentStep: this.state.currentStep + 1 });
    }

    goPrev() {
        this.setState({ currentStep: this.state.currentStep - 1 });
    }

    handleConfirm() {
        var state = this.state;
        var billingData = null;
        if (state.generateBilling) {
            billingData = {
                payment_split: state.payment_split,
                method: state.method,
                billing_due_date: state.billing_due_date ? state.billing_due_date.format('YYYY-MM-DD') : null,
            };
        }
        this.props.onConfirm({
            nature: state.nature,
            type: state.type,
            owner_name: state.owner_name,
            document: state.document,
            fenacon: state.fenacon,
            password: state.password,
            bird: state.bird ? 1 : 0,
            notes: state.notes,
            scheduled_at: state.scheduled_at ? state.scheduled_at.format('YYYY-MM-DD') : null,
            emission_date: state.emission_date ? state.emission_date.format('YYYY-MM-DD') : null,
            due_date: state.due_date ? state.due_date.format('YYYY-MM-DD') : null,
            amount: typeof state.amount === 'string' ? currency2Float(state.amount) : state.amount,
            billing: billingData,
        });
    }

    handleClose() {
        this.setState({ currentStep: 0 });
        this.props.onClose();
    }

    canProceedStep0() {
        return this.state.nature && this.state.type && this.state.owner_name;
    }

    canProceedStep1() {
        return this.state.emission_date && this.state.due_date;
    }

    canProceedStep2() {
        if (this.state.generateBilling) {
            return this.state.amount && this.state.billing_due_date && this.state.method;
        }
        return true;
    }

    renderStepDados() {
        var self = this;
        var st = this.state;
        return (
            <div>
                <div style={{ fontSize: 11, color: '#8c8c8c', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 12, fontWeight: 600 }}>Certificado</div>
                <Row gutter={16}>
                    <Col span={12}>
                        <div style={{ marginBottom: 8 }}>
                            <label style={{ fontWeight: 500, color: '#595959' }}>Natureza <span style={{ color: '#f5222d' }}>*</span></label>
                        </div>
                        <Radio.Group value={st.nature} onChange={function(e) { self.setState({ nature: e.target.value }); }}>
                            <Radio.Button value="PF">Pessoa Física</Radio.Button>
                            <Radio.Button value="PJ">Pessoa Jurídica</Radio.Button>
                        </Radio.Group>
                    </Col>
                    <Col span={12}>
                        <div style={{ marginBottom: 8 }}>
                            <label style={{ fontWeight: 500, color: '#595959' }}>Tipo <span style={{ color: '#f5222d' }}>*</span></label>
                        </div>
                        <Select value={st.type} onChange={function(v) { self.setState({ type: v }); }} style={{ width: '100%' }} placeholder="Selecione">
                            <Option value="E-CPF A1">E-CPF A1</Option>
                            <Option value="E-CPF A3">E-CPF A3</Option>
                            <Option value="E-CNPJ A1">E-CNPJ A1</Option>
                            <Option value="E-CNPJ A3">E-CNPJ A3</Option>
                        </Select>
                    </Col>
                </Row>
                <div style={{ fontSize: 11, color: '#8c8c8c', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 12, marginTop: 16, fontWeight: 600 }}>Titular</div>
                <Row gutter={16}>
                    <Col span={24}>
                        <div style={{ marginBottom: 8 }}>
                            <label style={{ fontWeight: 500, color: '#595959' }}>Nome do Sócio <span style={{ color: '#f5222d' }}>*</span></label>
                        </div>
                        <Input value={st.owner_name} onChange={function(e) { self.setState({ owner_name: e.target.value }); }} placeholder="Nome do sócio" />
                    </Col>
                </Row>
                <Row gutter={16} style={{ marginTop: 12 }}>
                    <Col span={12}>
                        <div style={{ marginBottom: 8 }}>
                            <label style={{ fontWeight: 500, color: '#595959' }}>{st.nature === 'PF' ? 'CPF' : 'CNPJ'}</label>
                        </div>
                        <InputMask
                            mask={st.nature === 'PF' ? '999.999.999-99' : '99.999.999/9999-99'}
                            formatChars={{ '9': '[0-9]' }}
                            maskChar={null}
                            value={st.document}
                            onChange={function(e) { self.setState({ document: e.target.value }); }}
                            placeholder={st.nature === 'PF' ? '000.000.000-00' : '00.000.000/0000-00'}
                        />
                    </Col>
                    <Col span={12}>
                        <div style={{ marginBottom: 8 }}>
                            <label style={{ fontWeight: 500, color: '#595959' }}>FENACON</label>
                        </div>
                        <Input value={st.fenacon} onChange={function(e) { self.setState({ fenacon: e.target.value }); }} placeholder="FENACON" />
                    </Col>
                </Row>
                <div style={{ fontSize: 11, color: '#8c8c8c', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 12, marginTop: 16, fontWeight: 600 }}>Outros</div>
                <Row gutter={16}>
                    <Col span={16}>
                        <div style={{ marginBottom: 8 }}>
                            <label style={{ fontWeight: 500, color: '#595959' }}>Senha cadastrada</label>
                        </div>
                        <Input
                            type={st.showPassword ? 'text' : 'password'}
                            value={st.password}
                            onChange={function(e) { self.setState({ password: e.target.value }); }}
                            placeholder="Senha"
                            suffix={React.createElement(Icon, {
                                type: st.showPassword ? 'eye' : 'eye-invisible',
                                style: { cursor: 'pointer', color: '#8c8c8c' },
                                onClick: function() { self.setState({ showPassword: !st.showPassword }); }
                            })}
                        />
                    </Col>
                    <Col span={8}>
                        <div style={{ marginBottom: 8 }}>
                            <label style={{ fontWeight: 500, color: '#595959' }}>BIRD <Tip>Renovação simplificada sem validação presencial.</Tip></label>
                        </div>
                        <Switch checked={st.bird} onChange={function(v) { self.setState({ bird: v }); }} />
                    </Col>
                    <Col span={24} style={{ marginTop: 12 }}>
                        <div style={{ marginBottom: 8 }}>
                            <label style={{ fontWeight: 500, color: '#595959' }}>Anotações</label>
                        </div>
                        <Input.TextArea value={st.notes} onChange={function(e) { self.setState({ notes: e.target.value }); }} rows={2} autoSize={{ minRows: 2, maxRows: 4 }} placeholder="Anotações" />
                    </Col>
                </Row>
            </div>
        );
    }

    renderStep0() {
        var cert = this.props.certificate || {};
        var customerName = cert.customer_name || cert.owner_name || '-';
        var emissionDate = cert.emission_date ? moment(cert.emission_date).format('DD/MM/YYYY') : '-';
        var dueDate = cert.due_date ? moment(cert.due_date).format('DD/MM/YYYY') : '-';

        var stateColor = '#8c8c8c';
        var stateBg = '#f5f5f5';
        if (cert.state === 'Ativo') { stateColor = '#52c41a'; stateBg = '#f6ffed'; }
        else if (cert.state === 'Expirando') { stateColor = '#faad14'; stateBg = '#fffbe6'; }
        else if (cert.state === 'Expirado') { stateColor = '#f5222d'; stateBg = '#fff1f0'; }

        var infoItem = function(icon, label, value, extra) {
            return React.createElement('div', { style: Object.assign({ textAlign: 'center', flex: 1 }, extra || {}) },
                React.createElement(Icon, { type: icon, style: { fontSize: 16, color: '#bfbfbf', marginBottom: 6, display: 'block' } }),
                React.createElement('div', { style: { fontSize: 11, color: '#8c8c8c', marginBottom: 2 } }, label),
                React.createElement('div', { style: { fontSize: 14, fontWeight: 500, color: '#262626' } }, value)
            );
        };

        return (
            <div>
                {/* Customer header */}
                <div style={{ textAlign: 'center', marginBottom: 24 }}>
                    <div style={{ width: 48, height: 48, borderRadius: '50%', background: '#e6f7ff', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', marginBottom: 12 }}>
                        <Icon type="safety-certificate" style={{ fontSize: 24, color: '#1890ff' }} />
                    </div>
                    <div style={{ fontSize: 18, fontWeight: 600, color: '#262626', marginBottom: 4 }}>{customerName}</div>
                    <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
                        <Tag color="blue" style={{ margin: 0 }}>{cert.type || '-'}</Tag>
                        <Tag style={{ margin: 0 }}>{cert.nature === 'PF' ? 'Pessoa Física' : 'Pessoa Jurídica'}</Tag>
                        <Tag color={stateColor} style={{ margin: 0 }}>{cert.state || 'Pendente'}</Tag>
                    </div>
                </div>

                {/* Certificate details */}
                <div style={{ background: '#fafafa', borderRadius: 8, padding: '20px 16px', display: 'flex', gap: 0, marginBottom: 24 }}>
                    {infoItem('calendar', 'Emissão', emissionDate)}
                    <div style={{ width: 1, background: '#e8e8e8', margin: '0 4px' }} />
                    {infoItem('calendar', 'Vencimento', dueDate)}
                    {cert.document ? React.createElement(React.Fragment, null,
                        React.createElement('div', { style: { width: 1, background: '#e8e8e8', margin: '0 4px' } }),
                        infoItem('idcard', 'Documento', cert.document)
                    ) : null}
                    {cert.amount ? React.createElement(React.Fragment, null,
                        React.createElement('div', { style: { width: 1, background: '#e8e8e8', margin: '0 4px' } }),
                        infoItem('dollar', 'Valor', 'R$ ' + toBRL(cert.amount))
                    ) : null}
                </div>

                {/* Info message */}
                <div style={{ background: stateBg, border: '1px solid ' + stateColor + '33', borderRadius: 8, padding: '14px 20px', display: 'flex', alignItems: 'center', gap: 12 }}>
                    <Icon type="info-circle" style={{ fontSize: 18, color: stateColor, flexShrink: 0 }} />
                    <div>
                        <div style={{ fontSize: 13, color: '#262626' }}>
                            O certificado atual será <strong>arquivado</strong> e um novo será criado com os dados atualizados.
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    onQuickYears(years) {
        var emission = this.state.emission_date || moment();
        this.setState({
            emission_date: moment(emission),
            due_date: moment(emission).add(years, 'years'),
        });
    }

    renderStep1() {
        var cert = this.props.certificate || {};
        var suggestedYears = isA3Type(cert.type) ? 3 : 1;
        var self = this;

        // Detect which quick option is currently active
        var activeQuick = null;
        if (this.state.emission_date && this.state.due_date) {
            var diffMonths = this.state.due_date.diff(this.state.emission_date, 'months');
            if (diffMonths === 12) activeQuick = 1;
            else if (diffMonths === 24) activeQuick = 2;
            else if (diffMonths === 36) activeQuick = 3;
            else if (diffMonths === 60) activeQuick = 5;
        }

        return (
            <div>
                <div style={{ marginBottom: 20 }}>
                    <div style={{ fontSize: 12, color: '#8c8c8c', marginBottom: 8 }}>Validade rápida</div>
                    <div style={{ display: 'flex', gap: 8 }}>
                        {[1, 2, 3, 5].map(function(y) {
                            var isActive = activeQuick === y;
                            var isSuggested = y === suggestedYears;
                            return (
                                <Button
                                    key={y}
                                    size="small"
                                    type={isActive ? 'primary' : 'default'}
                                    onClick={function() { self.onQuickYears(y); }}
                                    style={{
                                        borderRadius: 16,
                                        borderColor: isSuggested && !isActive ? '#52c41a' : undefined,
                                        color: isSuggested && !isActive ? '#52c41a' : undefined,
                                    }}
                                >
                                    {y + (y === 1 ? ' ano' : ' anos')}
                                    {isSuggested && !isActive && ' ★'}
                                </Button>
                            );
                        })}
                    </div>
                </div>
                <Row gutter={24}>
                    <Col span={12}>
                        <div style={{ marginBottom: 8 }}>
                            <label style={{ fontWeight: 500, color: '#595959' }}>
                                <Icon type="calendar" style={{ marginRight: 6 }} />
                                Data de Emissão <span style={{ color: '#f5222d' }}>*</span>
                            </label>
                        </div>
                        <DatePicker
                            value={this.state.emission_date}
                            onChange={this.onEmissionChange}
                            style={{ width: '100%' }}
                            placeholder="Selecione a data"
                            getCalendarContainer={function(trigger) { return trigger.parentNode; }}
                        />
                    </Col>
                    <Col span={12}>
                        <div style={{ marginBottom: 8 }}>
                            <label style={{ fontWeight: 500, color: '#595959' }}>
                                <Icon type="calendar" style={{ marginRight: 6 }} />
                                Data de Vencimento <span style={{ color: '#f5222d' }}>*</span>
                            </label>
                        </div>
                        <DatePicker
                            value={this.state.due_date}
                            onChange={this.onDueDateChange}
                            style={{ width: '100%' }}
                            placeholder="Selecione a data"
                            getCalendarContainer={function(trigger) { return trigger.parentNode; }}
                        />
                    </Col>
                </Row>
            </div>
        );
    }

    renderStep2() {
        var billing = this.state.generateBilling;
        var ctx = this;
        return (
            <div>
                {/* Valor do certificado */}
                <div style={{ marginBottom: 24 }}>
                    <div style={{ marginBottom: 8 }}>
                        <label style={{ fontWeight: 500, color: '#595959' }}>
                            <Icon type="dollar" style={{ marginRight: 6 }} />
                            Valor do certificado <span style={{ fontWeight: 400, color: '#bfbfbf', fontSize: 12 }}>(opcional)</span>
                        </label>
                    </div>
                    <InputCurrency
                        value={this.state.amount}
                        onChange={this.onAmountChange}
                        style={{ width: '100%' }}
                    />
                </div>

                {/* Billing option cards */}
                <div style={{ marginBottom: 8 }}>
                    <label style={{ fontWeight: 500, color: '#595959' }}>
                        <Icon type="file-text" style={{ marginRight: 6 }} />
                        Cobrança nos serviços extras
                    </label>
                </div>
                <div style={{ display: 'flex', gap: 12 }}>
                    {/* Option: No billing */}
                    <div
                        onClick={function() { ctx.onGenerateBillingChange(false); }}
                        style={{
                            flex: 1, padding: '16px 20px', borderRadius: 8, cursor: 'pointer',
                            border: '1.5px solid ' + (!billing ? '#1890ff' : '#e8e8e8'),
                            background: !billing ? '#e6f7ff' : '#fff',
                            transition: 'all 0.2s',
                        }}
                    >
                        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 6 }}>
                            <Icon type={!billing ? 'check-circle' : 'close-circle'}
                                theme={!billing ? 'filled' : 'outlined'}
                                style={{ fontSize: 18, color: !billing ? '#1890ff' : '#bfbfbf' }} />
                            <span style={{ fontWeight: 600, fontSize: 14, color: !billing ? '#1890ff' : '#595959' }}>
                                Não vincular cobrança
                            </span>
                        </div>
                        <div style={{ fontSize: 12, color: '#8c8c8c', paddingLeft: 28 }}>
                            Apenas registrar o valor do certificado sem gerar cobrança.
                        </div>
                    </div>

                    {/* Option: Generate billing */}
                    <div
                        onClick={function() { ctx.onGenerateBillingChange(true); }}
                        style={{
                            flex: 1, padding: '16px 20px', borderRadius: 8, cursor: 'pointer',
                            border: '1.5px solid ' + (billing ? '#52c41a' : '#e8e8e8'),
                            background: billing ? '#f6ffed' : '#fff',
                            transition: 'all 0.2s',
                        }}
                    >
                        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 6 }}>
                            <Icon type={billing ? 'check-circle' : 'dollar'}
                                theme={billing ? 'filled' : 'outlined'}
                                style={{ fontSize: 18, color: billing ? '#52c41a' : '#bfbfbf' }} />
                            <span style={{ fontWeight: 600, fontSize: 14, color: billing ? '#52c41a' : '#595959' }}>
                                Vincular cobrança
                            </span>
                        </div>
                        <div style={{ fontSize: 12, color: '#8c8c8c', paddingLeft: 28 }}>
                            Gerar cobrança automaticamente nos serviços extras do cliente.
                        </div>
                    </div>
                </div>

                {/* Billing config — slides in when selected */}
                {billing && (
                    <div style={{ marginTop: 16, background: '#f6ffed', border: '1px solid #b7eb8f', borderRadius: '0 0 8px 8px', borderTop: '2px solid #52c41a', padding: 20 }}>
                        <Row gutter={24}>
                            <Col span={8}>
                                <div style={{ marginBottom: 8 }}>
                                    <label style={{ fontWeight: 500, color: '#595959', fontSize: 13 }}>Parcelas</label>
                                </div>
                                <Select
                                    value={this.state.payment_split}
                                    onChange={this.onSplitChange}
                                    style={{ width: '100%' }}
                                >
                                    {SPLIT_OPTIONS.map(function(n) {
                                        return <Option key={n} value={n}>{n + 'x'}</Option>;
                                    })}
                                </Select>
                            </Col>
                            <Col span={8}>
                                <div style={{ marginBottom: 8 }}>
                                    <label style={{ fontWeight: 500, color: '#595959', fontSize: 13 }}>Forma de pagamento</label>
                                </div>
                                <Select
                                    value={this.state.method}
                                    onChange={this.onMethodChange}
                                    style={{ width: '100%' }}
                                >
                                    {METHODS.map(function(m) {
                                        return <Option key={m.value} value={m.value}>{m.label}</Option>;
                                    })}
                                </Select>
                            </Col>
                            <Col span={8}>
                                <div style={{ marginBottom: 8 }}>
                                    <label style={{ fontWeight: 500, color: '#595959', fontSize: 13 }}>Vencimento 1ª parcela</label>
                                </div>
                                <DatePicker
                                    value={this.state.billing_due_date}
                                    onChange={this.onBillingDueDateChange}
                                    style={{ width: '100%' }}
                                    placeholder="Selecione a data"
                                    getCalendarContainer={function(trigger) { return trigger.parentNode; }}
                                />
                            </Col>
                        </Row>
                    </div>
                )}
            </div>
        );
    }

    renderStep3() {
        var cert = this.props.certificate || {};
        var state = this.state;
        var oldEmission = cert.emission_date ? moment(cert.emission_date).format('DD/MM/YYYY') : '-';
        var oldDue = cert.due_date ? moment(cert.due_date).format('DD/MM/YYYY') : '-';
        var newEmission = state.emission_date ? state.emission_date.format('DD/MM/YYYY') : '-';
        var newDue = state.due_date ? state.due_date.format('DD/MM/YYYY') : '-';
        var oldAmount = cert.amount ? 'R$ ' + toBRL(parseFloat(cert.amount)) : '-';
        var newAmount = state.amount ? 'R$ ' + toBRL(state.amount) : '-';

        var selectedMethod = METHODS.filter(function(m) { return m.value === state.method; });
        var methodLabel = selectedMethod.length > 0 ? selectedMethod[0].label : '-';

        return (
            <div>
                <Row gutter={24}>
                    <Col span={12}>
                        <div style={{ background: '#fff1f0', border: '1px solid #ffa39e', borderRadius: 6, padding: 16 }}>
                            <div style={{ fontWeight: 600, color: '#cf1322', marginBottom: 12, fontSize: 14 }}>
                                <Icon type="file-text" style={{ marginRight: 6 }} />
                                Certificado Atual
                            </div>
                            <Descriptions column={1} size="small">
                                <Descriptions.Item label="Tipo"><Tag color="blue">{cert.type || '-'}</Tag> {cert.nature === 'PF' ? 'Pessoa Física' : 'Pessoa Jurídica'}</Descriptions.Item>
                                <Descriptions.Item label="Titular">{cert.owner_name || '-'}</Descriptions.Item>
                                <Descriptions.Item label="Emissão">{oldEmission}</Descriptions.Item>
                                <Descriptions.Item label="Vencimento">{oldDue}</Descriptions.Item>
                                <Descriptions.Item label="Valor">{oldAmount}</Descriptions.Item>
                            </Descriptions>
                            <Tag color="red" style={{ marginTop: 8 }}>Será arquivado</Tag>
                        </div>
                    </Col>
                    <Col span={12}>
                        <div style={{ background: '#f6ffed', border: '1px solid #b7eb8f', borderRadius: 6, padding: 16 }}>
                            <div style={{ fontWeight: 600, color: '#389e0d', marginBottom: 12, fontSize: 14 }}>
                                <Icon type="file-add" style={{ marginRight: 6 }} />
                                Novo Certificado
                            </div>
                            <Descriptions column={1} size="small">
                                <Descriptions.Item label="Tipo"><Tag color="blue">{state.type}</Tag> {state.nature === 'PF' ? 'Pessoa Física' : 'Pessoa Jurídica'}</Descriptions.Item>
                                <Descriptions.Item label="Titular">{state.owner_name || '-'}</Descriptions.Item>
                                <Descriptions.Item label="Emissão">{newEmission}</Descriptions.Item>
                                <Descriptions.Item label="Vencimento">{newDue}</Descriptions.Item>
                                <Descriptions.Item label="Valor">{newAmount}</Descriptions.Item>
                            </Descriptions>
                            <Tag color="green" style={{ marginTop: 8 }}>Novo registro</Tag>
                        </div>
                    </Col>
                </Row>
                {state.generateBilling && (
                    <div style={{ marginTop: 20, background: '#e6f7ff', border: '1px solid #91d5ff', borderRadius: 6, padding: 16 }}>
                        <div style={{ fontWeight: 600, color: '#096dd9', marginBottom: 8, fontSize: 14 }}>
                            <Icon type="dollar" style={{ marginRight: 6 }} />
                            Cobrança automática
                        </div>
                        <Descriptions column={3} size="small">
                            <Descriptions.Item label="Valor">{newAmount}</Descriptions.Item>
                            <Descriptions.Item label="Parcelas">{state.payment_split + 'x'}</Descriptions.Item>
                            <Descriptions.Item label="Pagamento">{methodLabel}</Descriptions.Item>
                            <Descriptions.Item label="1ª Parcela">
                                {state.billing_due_date ? state.billing_due_date.format('DD/MM/YYYY') : '-'}
                            </Descriptions.Item>
                        </Descriptions>
                    </div>
                )}
            </div>
        );
    }

    render() {
        var step = this.state.currentStep;
        var isLoading = this.props.renewLoading;

        var canNext = true;
        if (step === 0) canNext = this.canProceedStep0();
        if (step === 1) canNext = this.canProceedStep1();
        if (step === 2) canNext = this.canProceedStep2();

        var footer = [];

        if (step > 0) {
            footer.push(
                <Button key="prev" onClick={this.goPrev} disabled={isLoading} style={{ marginRight: 8 }}>
                    <Icon type="left" /> Voltar
                </Button>
            );
        }

        footer.push(
            <Button key="cancel" onClick={this.handleClose} disabled={isLoading} style={{ marginRight: 8 }}>
                Cancelar
            </Button>
        );

        if (step < 3) {
            footer.push(
                <Button key="next" type="primary" onClick={this.goNext} disabled={!canNext}>
                    Próximo <Icon type="right" />
                </Button>
            );
        }

        if (step === 3) {
            footer.push(
                <Button
                    key="confirm"
                    type="primary"
                    loading={isLoading}
                    onClick={this.handleConfirm}
                    style={{ background: '#52c41a', borderColor: '#52c41a' }}
                    icon="check-circle"
                >
                    Confirmar Renovação
                </Button>
            );
        }

        return (
            <Modal
                title={
                    <span>
                        <Icon type="sync" style={{ color: '#52c41a', marginRight: 8 }} />
                        Renovar Certificado Digital
                    </span>
                }
                visible={this.props.visible}
                onCancel={this.handleClose}
                footer={footer}
                width={700}
                destroyOnClose
                maskClosable={false}
                zIndex={9999}
                getContainer={function() { return document.body; }}
            >
                <Steps current={step} size="small" style={{ marginBottom: 32 }}>
                    <Step title="Dados" icon={<Icon type="form" />} />
                    <Step title="Datas" icon={<Icon type="calendar" />} />
                    <Step title="Valor e Cobrança" icon={<Icon type="dollar" />} />
                    <Step title="Resumo" icon={<Icon type="check-circle" />} />
                </Steps>

                {step === 0 && this.renderStepDados()}
                {step === 1 && this.renderStep1()}
                {step === 2 && this.renderStep2()}
                {step === 3 && this.renderStep3()}
            </Modal>
        );
    }
}

export default RenewalWizard;
